import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationWeightPluginService extends InspectionPluginService {
  public weightUnitsKeys: any = [
    { value: 1, label: 'plugins.installationweight.kilos' },
    { value: 2, label: 'plugins.installationweight.metric-tons' },
    { value: 3, label: 'plugins.installationweight.pounds' }
  ];

  public weightUnits: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public getWeightUnits() {
    return this.weightUnits;
  }

  public updateWeight(inspectionId: string, pointId: string, pluginId: string, weights: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, weights).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public applyTranslations() {
    this.weightUnits = [];
    this.copyTranslationValues(this.weightUnitsKeys, this.weightUnits, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, weights: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, weights, 'Weights').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
